import { accountPipelinesClient, accountPipelineStagesClient } from '@/api/clients/index';
import { isBoolean } from 'lodash-es';

export default (accountId = null) => {
  if (!accountId) {
    return false;
  }

  return {
    name: 'pipeline_stage',
    label: 'Pipeline stage',
    fetchOptions: async (queryParams = {}) => {
      try {
        const response = await accountPipelinesClient.list(accountId, {
          params: {
            ...queryParams,
            page: {
              ...(queryParams.page || {}),
              size: 5,
            },
            include: 'pipeline_stages',
          },
        });

        return Promise.resolve({
          data: (response?.data?.data || []).map((pipeline) => ({
            id: pipeline.id,
            label: pipeline.name,
            options: pipeline.pipelineStages.map((pipelineStage) => ({
              value: pipelineStage.id,
              label: pipelineStage.name,
            })),
          })),
          meta: response?.data?.meta || null,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getMessage: async (value, cb) => {
      if (isBoolean(value)) {
        cb(value);
      }

      let ids = value;

      if (typeof ids === 'string') {
        ids = ids.split(',');
      }

      if (Array.isArray(ids) === false) {
        ids = [ids];
      }

      try {
        const response = await accountPipelineStagesClient.list(accountId, {
          filter: { id: ids },
          include: 'pipeline',
        });

        const labels = ids.map((id) => {
          const pipelineStage = response.data.find((item) => item.id === id);

          if (!pipelineStage) {
            return id;
          }

          return [pipelineStage.name, pipelineStage?.pipeline?.name].filter(Boolean).join('@');
        });

        return Promise.resolve(cb(labels));
      } catch (error) {
        return Promise.resolve(cb(value));
      }
    },
    filters: [
      {
        name: 'pipeline_stage__is_assigned',
        label: 'Is not assigned to pipeline stage',
        input: 'none',
        value: false,
        message: () => 'Is not assigned to **pipeline stage**',
      },
      {
        name: 'pipeline_stage__is',
        label: 'Pipeline stage is',
        input: 'grouped-chips',
        value: null,
        message: (value) => `**pipeline stage** is **${value}**`,
      },
      {
        name: 'pipeline_stage__is_not',
        label: 'Pipeline stage is not',
        input: 'grouped-chips',
        value: null,
        message: (value) => `**pipeline stage** is not **${value}**`,
      },
      {
        name: 'pipeline_stage__in',
        label: 'Pipeline stage is one of',
        input: 'grouped-chips:multiple',
        value: [],
        message: (value) => `**pipeline stage** is one of **${value.join(', ')}**`,
      },
      {
        name: 'pipeline_stage__not_in',
        label: 'Pipeline stage is not one of',
        input: 'grouped-chips:multiple',
        value: [],
        message: (value) => `**pipeline stage** is not one of **${value.join(', ')}**`,
      },
    ],
  };
};
